export const mapTypeAndActivityDescriptions = (taxEntries, { types, activities }) => taxEntries.map(taxEntry => {
  const foundType = types.find(type => type.value === taxEntry.type);
  const typeDesc = foundType && foundType.desc;

  const foundActivity = activities.find(activity => activity.value === taxEntry.activity);
  const activityDesc = foundActivity && foundActivity.desc;

  return {
    ...taxEntry,
    typeDesc,
    activityDesc,
    slAccount: taxEntry.type && taxEntry.activity ? `${taxEntry.type}_${taxEntry.activity}` : null,
  };
});
